import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import Home from "./pages/Home";
import VCI from "./pages/VCI";
import NDVI from "./pages/NDVI";
import ETA from "./pages/Evapotranspiration";
import LandCover from "./pages/LandCover";
import WeatherMonitoring from "./pages/WeatherMonitoring";
import Precipitation from "./pages/Precipitation";
import PrecipitationMonthly from "./pages/Precipitation-monthly";
import LandDegradation from "./pages/LandDegradation";

import ReloadHandler from "./RelaodHandler";

import store from "./store/store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import ResetPass from "./pages/PasswordReset";
import "react-toastify/dist/ReactToastify.css";
import VHI from "./pages/VHI";
import Masking from "./pages/Masking";
import Reporting from "./pages/Masking/reporting";
import ASI from "./pages/ASI";
import Prediction from "./pages/Prediction";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./components/Theme";
import SPI1 from "./pages/SPI-1";
import SPI2 from "./pages/SPI-2";
import SPI3 from "./pages/SPI-3";
import SPI6 from "./pages/SPI-6";
import SPI9 from "./pages/SPI-9";
import SPI12 from "./pages/SPI-12";
import AdminHomePage from "./pages/Home/AdminPanel";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";
import AuthPage from "./components/Sign/SignModal";
import useTokenValidator from "./hooks/checkAuth";
const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/account",
    element: <AuthPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/admin/*",
    element: <AdminDashboard />,
  },
  {
    path: "VCI",
    element: <VCI />,
  },
  {
    path: "vegetation-monitoring/:type/:index",
    element: <NDVI />,
  },
  {
    path: "vegetation-monitoring/:type/:index",
    element: <NDVI />,
  },
  {
    path: "map",
    element: <NDVI />,
  },
  {
    path: "Evapotranspiration",
    element: <ETA />,
  },
  // {
  //   path: "land-degredation-monitoring/:type/:index",
  //   element: <LandCover />,
  // },
  {
    path: "land-monitoring/:type/:index",
    element: <LandCover />,
  },
  {
    path: "Weather-Monitoring",
    element: <WeatherMonitoring />,
  },
  {
    path: "weather-monitoring/:type/:index",
    element: <Precipitation />,
  },
  {
    path: "Precipitation-monthly",
    element: <PrecipitationMonthly />,
  },
  {
    path: "VHI",
    element: <VHI />,
  },
  {
    path: "ASI",
    element: <ASI />,
  },
  {
    path: "PasswordReset/:reset_token",
    element: <ResetPass />,
  },
  {
    path: "monitoring",
    element: <Masking />,
  },
  {
    path: "reporting",
    element: <Reporting />,
  },
  {
    path: "prediction",
    element: <Prediction />,
  },
  {
    path: "land-degradation",
    element: <LandDegradation />,
  },
  {
    path: "drought-monitoring/:type/:index",
    element: <SPI1 />,
  },
  {
    path: "SPI-2",
    element: <SPI2 />,
  },
  {
    path: "SPI-3",
    element: <SPI3 />,
  },
  {
    path: "SPI-6",
    element: <SPI6 />,
  },
  {
    path: "SPI-9",
    element: <SPI9 />,
  },
  {
    path: "SPI-12",
    element: <SPI12 />,
  },
]);
function App() {
  // useTokenValidator();
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ReloadHandler />
        <RouterProvider router={router} />
        <ToastContainer
          position="top-left"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{ zIndex: 9999 }}
        />
      </Provider>
    </ThemeProvider>
  );
}

export default App;
